import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Link } from 'react-router';
import moment from 'moment';
import Tooltip from 'rc-tooltip';
import { ColumnExportButton, Table, Dollars } from 'barnyard/components';
import { BarnyardIcon } from 'barnyard/icons';
import AlertItem from './AlertItem';
import { format_dollars, format_percent } from '~/app/common/utils';


const className = 'rCorporate--PricingTierAlert';

const columnsNameAndSku = [{
  Header: 'Name',
  accessor: 'item_name',
  width: 550,
}, {
  Header: 'SKU',
  accessor: 'supply_sku',
}];
const pricingInTable = [{
  Header: () => (
    <span>
      Pricing Tiers {' '}
      <Tooltip
        overlay='Hover the prices below to see which clinics paid that price'
      >
        <BarnyardIcon icon={['fas', 'question-circle']} />
      </Tooltip>
    </span>
  ),
  accessor: 'pricing_tiers',
  width: 400,
  Cell: ({ value }) => _.map(value, (buyers, price) => (
    <span className={`${className}__price`} key={price}>
      <Tooltip
        key={price}
        overlay={_.map(buyers, buyer => <p>{buyer}</p>)}
      >
        <Dollars includeCents={true} integer={price} />
      </Tooltip>
    </span>
  ))
}];

const pricingInExport = [{
  Header: 'Pricing Tiers',
  id: 'pricing_tiers',
  accessor: row => (
    _.map(row.pricing_tiers, (buyers, price) => format_dollars({ integer: parseInt(price), include_cents: true }))
  )
}];
const deltaColumn = [{
  Header: 'Delta',
  id: 'delta',
  accessor: row => format_percent(row.delta)
}];
const linkColumn = [{
  Header: 'Link',
  accessor: 'item_id',
  Cell: ({ value }) => (/* eslint-disable-line react/prop-types */
    <Link to={`/corporate/analyze/item/${value}`}>
      View Item <BarnyardIcon icon={['fal', 'angle-right']} />
    </Link>
  )
}];

const tableColumns = columnsNameAndSku.concat(pricingInTable).concat(deltaColumn).concat(linkColumn);
const exportColumns = columnsNameAndSku.concat(pricingInExport).concat(deltaColumn);

class PricingTierAlert extends Component {
  render() {
    const { alert } = this.props;

    return (
      <AlertItem
        alert={alert}
        onIsFlaggedChange={this.props.onIsFlaggedChange}
        date={moment(alert.date).format('MMMM YYYY')}
        icon='usd'
        title={(
          <div>
            Multiple pricing tiers found for {' '}
            <Link to={`/corporate/analyze/supplier/${alert.value.supplier_id}`}>
              {alert.value.supplier_short_name}
            </Link>
          </div>
        )}
        content={(
          <Table
            actions={
              <div className='u-paddingTop10'>
                <ColumnExportButton
                  filename='Vetcove_Pricing_Tiers.csv'
                  data={alert.value.supplies}
                  columns={exportColumns}
                >
                  Download
                </ColumnExportButton>
              </div>
            }
            size='small'
            columns={tableColumns}
            data={alert.value.supplies}
            pageSize={alert.value.supplies.length || 10}
            showPagination={false}
          />
        )}
        {...this.props}
      />
    );
  }
}

PricingTierAlert.propTypes = {
  alert: PropTypes.object.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired
};

export default PricingTierAlert;
